import script from "./InfiniteCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./InfiniteCarousel.vue?vue&type=script&setup=true&lang=js"

import "./InfiniteCarousel.vue?vue&type=style&index=0&id=4b8a81f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8a81f0"]])

export default __exports__